import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/meen-home-mission.jpg'
import _imports_1 from '@/assets/meen-home-jobs.jpg'
import _imports_2 from '@/assets/meen-sector-metal.jpg'
import _imports_3 from '@/assets/meen-sector-1.jpg'
import _imports_4 from '@/assets/meen-sector-2.jpg'
import _imports_5 from '@/assets/meen-sector-3.jpg'
import _imports_6 from '@/assets/meen-sector-4.jpg'
import _imports_7 from '@/assets/meen-sector-5.jpg'


const _withScopeId = n => (_pushScopeId("data-v-80b6da08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page home" }
const _hoisted_2 = { class: "hero-banner" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = { class: "hero-banner-content animated-block" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("Build connections"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("and share engineering ideas")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ic ic-arrow-right" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hero-banner-bottom animated-block" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Follow us"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.facebook.com/profile.php?id=100063737761079",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "ic s ic-facebook"
  }),
  /*#__PURE__*/_createTextVNode(" / "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.linkedin.com/in/engenuity-midlands-engineering-network-1a30881aa/",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "ic s ic-linkedin"
  }),
  /*#__PURE__*/_createTextVNode(" / "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://x.com/Engenuity2",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "ic s ic-x"
  })
], -1))
const _hoisted_8 = { class: "cta-text" }
const _hoisted_9 = { class: "wrapper" }
const _hoisted_10 = { class: "content animated-block" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cta-text-content" }, "The Engenuity Engineering Network was set up to promote market-led innovation, stakeholder collaboration, best practices and product / trade development among the Midlands Engineering Cluster.", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ic ic-arrow-right-d" }, null, -1))
const _hoisted_13 = { class: "highlight" }
const _hoisted_14 = { class: "wrapper" }
const _hoisted_15 = { class: "container" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column-left animated-block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column-subtitle" }, "Mission"),
  /*#__PURE__*/_createElementVNode("h2", null, "We help members build links, share experience and undertake joint commercial activity."),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "column-image"
  })
], -1))
const _hoisted_17 = { class: "column-right animated-block" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column-text" }, "The network will include events to share expertise and best practice based around specific topics, facilitate guest speakers, member presentations, workshops and networking (physical and virtual) so that companies can learn from each other and access support from peers and stakeholder organisations, such as the industry, knowledge sector and other enterprise support bodies", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ic ic-arrow-right" }, null, -1))
const _hoisted_20 = { class: "columns" }
const _hoisted_21 = { class: "wrapper" }
const _hoisted_22 = { class: "container" }
const _hoisted_23 = { class: "column-left animated-block" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column-subtitle" }, "Network", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Becoming a member", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column-text" }, "Becoming a member will allow you to showcase your company to an extended online audience and raise awareness of products/services, access a private resource section also with useful information, industry data and other sector-specific knowledge. You’ll also have access to network with industry and peers to exchange of ideas and opportunities.", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ic ic-arrow-right" }, null, -1))
const _hoisted_28 = { class: "column-right animated-block" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ic xl ic-building" }, null, -1))
const _hoisted_30 = { class: "column-count" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column-unit" }, "Companies", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column-text" }, "are part of the network", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ic ic-arrow-right" }, null, -1))
const _hoisted_34 = {
  key: 0,
  class: "jobs"
}
const _hoisted_35 = { class: "wrapper" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title animated-block" }, "Job opportunities", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle animated-block" }, "Discover Companies Seeking Talent in Our Network", -1))
const _hoisted_38 = { class: "container" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "jobs-cover animated-block"
}, null, -1))
const _hoisted_40 = { class: "jobs-list" }
const _hoisted_41 = { class: "actions animated-block" }
const _hoisted_42 = { class: "sectors" }
const _hoisted_43 = { class: "wrapper" }
const _hoisted_44 = { class: "container" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-banner animated-block" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Engenuity Sectors"),
  /*#__PURE__*/_createElementVNode("div", { class: "subtitle white" }, "The Network currently consists of member companies with expertise in a variety of sectors.")
], -1))
const _hoisted_46 = { class: "items" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "sector-image"
}, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sector-name" }, "Metal Fabrication", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "sector-image"
}, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sector-name" }, "Design", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  class: "sector-image"
}, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sector-name" }, "Manufacturing Services", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  class: "sector-image"
}, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sector-name" }, "Installation", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "",
  class: "sector-image"
}, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sector-name" }, "Distribution", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: "",
  class: "sector-image"
}, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sector-name" }, "Robotics", -1))
const _hoisted_59 = { class: "actions animated-block" }
const _hoisted_60 = {
  key: 1,
  class: "events"
}
const _hoisted_61 = { class: "wrapper" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title animated-block" }, "Events", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle blue animated-block" }, "A Comprehensive Guide to Upcoming Occasions and Gatherings", -1))
const _hoisted_64 = { class: "main-event animated-block" }
const _hoisted_65 = ["src"]
const _hoisted_66 = { class: "main-event-date" }
const _hoisted_67 = { class: "day" }
const _hoisted_68 = { class: "month" }
const _hoisted_69 = { class: "main-event-header" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "ic m ic-parrow-left" }, null, -1))
const _hoisted_71 = { class: "main-event-title" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "ic m ic-parrow-right" }, null, -1))
const _hoisted_73 = { class: "main-event-location" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ic s ic-pin-w" }, null, -1))
const _hoisted_75 = { class: "main-event-excerpt" }
const _hoisted_76 = {
  key: 0,
  class: "events-list"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "animated-block" }, "Upcoming events", -1))
const _hoisted_78 = { class: "event-post-date" }
const _hoisted_79 = { class: "day" }
const _hoisted_80 = { class: "month" }
const _hoisted_81 = { class: "event-post-info" }
const _hoisted_82 = { class: "event-post-title" }
const _hoisted_83 = { class: "event-post-location" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ic s ic-pin" }, null, -1))
const _hoisted_85 = { class: "actions animated-block" }
const _hoisted_86 = {
  key: 2,
  class: "news"
}
const _hoisted_87 = { class: "wrapper" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title animated-block" }, "News", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle blue animated-block" }, "Unveiling Stories: Inside the Latest News Highlights", -1))
const _hoisted_90 = { class: "latest-news" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "blue animated-block" }, "Latest news", -1))
const _hoisted_92 = { class: "container" }
const _hoisted_93 = { class: "actions animated-block" }
const _hoisted_94 = {
  key: 3,
  class: "featured-members"
}
const _hoisted_95 = { class: "wrapper" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Featured members", -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Celebrating Our Network: Highlighting Key Contributors and Influencers", -1))
const _hoisted_98 = { class: "container" }
const _hoisted_99 = ["src"]
const _hoisted_100 = { class: "member-name" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ic xl ic-logo-b" }, null, -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Midlands Engineering Network")
], -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", null, "discover all members")
], -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ic m ic-arrows-right" }, null, -1))

import { onBeforeUnmount, onMounted, ref } from 'vue';
import NewsPost from '../components/NewsPost.vue';
import { BlogPost } from '../types/BlogPost';
import { EventPost } from '../types/EventPost';
import { Job } from '../types/Job';
import { Company } from '../types/Company';
import { Unsubscribe, collection, getCountFromServer, limit, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { format } from 'date-fns';
import { firestore } from '@/services/FirebaseService';
import JobPost from '@/components/JobPost.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const posts = ref<BlogPost[]>([]);
const events = ref<EventPost[]>([]);
const members = ref<Company[]>([]);
const jobs = ref<Job[]>([]);
const postsRef = ref<Unsubscribe | null>(null);
const eventsRef = ref<Unsubscribe | null>(null);
const membersRef = ref<Unsubscribe | null>(null);
const jobsRef = ref<Unsubscribe | null>(null);
const companyCount = ref<number>(0);

const getCompanyCount = async () => {
  const { count } = (await getCountFromServer(query(collection(firestore, 'companies'), where('accepted', '==', true)))).data();
  companyCount.value = count;
};

onMounted(() => {
  postsRef.value = onSnapshot(query(collection(firestore, 'posts'), where('type', '==', 'news'), where('active', '==', true), orderBy('created_at', 'desc'), limit(4)), (snap) => {
    posts.value = snap.docs.map((doc) => {
      const data = doc.data();
      return {
        ...data,
        categories: data.categories || [],
        published_at: data.published_at?.toDate(),
        created_at: data.created_at.toDate(),
        updated_at: data.created_at.toDate(),
      } as BlogPost;
    });
    console.log(posts.value);
  });
  eventsRef.value = onSnapshot(query(collection(firestore, 'posts'), where('type', '==', 'event'), where('active', '==', true), where('start_date', '>=', new Date()), orderBy('start_date', 'asc'), limit(4)), (snap) => {
    events.value = snap.docs.map((doc) => {
      const data = doc.data();
      return {
        ...data,
        start_date: data.start_date.toDate(),
        end_date: data.end_date?.toDate(),
        created_at: data.created_at.toDate(),
        updated_at: data.updated_at.toDate(),
      } as EventPost;
    });
    console.log(events.value);
  });
  membersRef.value = onSnapshot(query(collection(firestore, 'companies'), where('accepted', '==', true), where('featured', '==', true), orderBy('created_at', 'desc'), limit(3)), (snap) => {
    members.value = snap.docs.map((doc) => {
      const data = doc.data();
      return {
        ...data,
        created_at: data.created_at.toDate(),
        updated_at: data.updated_at.toDate(),
      } as unknown as Company;
    });
    console.log(members.value);
  });
  jobsRef.value = onSnapshot(query(collection(firestore, 'jobs'), where('active', '==', true), orderBy('created_at', 'desc'), limit(3)), (snap) => {
    jobs.value = snap.docs.map((doc) => {
      const data = doc.data();
      return {
        ...data,
        created_at: data.created_at.toDate(),
        updated_at: data.updated_at.toDate(),
      } as unknown as Job;
    });
    console.log(jobs.value);
  });
  getCompanyCount();
});

onBeforeUnmount(() => {
  postsRef.value?.();
  eventsRef.value?.();
  membersRef.value?.();
  jobsRef.value?.();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_router_link, {
            class: "btn",
            to: "/register"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Join the network "),
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _hoisted_7
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_router_link, {
            class: "link",
            to: "/members"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Read more "),
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_router_link, {
              class: "btn",
              to: "/register"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Access support "),
                _hoisted_19
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _hoisted_25,
            _hoisted_26,
            _createVNode(_component_router_link, {
              class: "btn blue",
              to: "/about"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" More about us "),
                _hoisted_27
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, _toDisplayString(companyCount.value), 1),
            _hoisted_31,
            _hoisted_32,
            _createVNode(_component_router_link, {
              class: "btn dark",
              to: "/register"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Join the network "),
                _hoisted_33
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    (jobs.value.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobs.value, (job) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "item animated-block",
                    key: job.id
                  }, [
                    _createVNode(JobPost, { post: job }, null, 8, ["post"])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_router_link, {
                class: "btn outlined",
                to: "/jobs"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("view all jobs")
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_42, [
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_router_link, {
              class: "sector animated-block",
              to: "/members?sector=Metal Fabrication"
            }, {
              default: _withCtx(() => [
                _hoisted_47,
                _hoisted_48
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "sector animated-block",
              to: "/members?sector=Design"
            }, {
              default: _withCtx(() => [
                _hoisted_49,
                _hoisted_50
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "sector animated-block",
              to: "/members?sector=Manufacturing Services"
            }, {
              default: _withCtx(() => [
                _hoisted_51,
                _hoisted_52
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "sector animated-block",
              to: "/members?sector=Installation"
            }, {
              default: _withCtx(() => [
                _hoisted_53,
                _hoisted_54
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "sector animated-block",
              to: "/members?sector=Distribution"
            }, {
              default: _withCtx(() => [
                _hoisted_55,
                _hoisted_56
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "sector animated-block",
              to: "/members?sector=Robotics"
            }, {
              default: _withCtx(() => [
                _hoisted_57,
                _hoisted_58
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createVNode(_component_router_link, {
              class: "btn outlined",
              to: "/about#sectors"
            }, {
              default: _withCtx(() => [
                _createTextVNode("view all sectors")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "btn",
              to: "/register"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Join the network")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    (events.value.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _hoisted_62,
            _hoisted_63,
            _createElementVNode("div", _hoisted_64, [
              _createVNode(_component_router_link, {
                to: `/events/${events.value[0].slug}`
              }, {
                default: _withCtx(() => [
                  (events.value[0].picture)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: events.value[0].picture.url,
                        alt: "",
                        class: "main-event-image"
                      }, null, 8, _hoisted_65))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["to"]),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, _toDisplayString(_unref(format)(events.value[0].start_date, 'dd')), 1),
                _createElementVNode("div", _hoisted_68, _toDisplayString(_unref(format)(events.value[0].start_date, 'MMM')) + ".", 1)
              ]),
              _createVNode(_component_router_link, {
                to: `/events/${events.value[0].slug}`,
                class: "main-event-info"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_69, [
                    _hoisted_70,
                    _createElementVNode("div", _hoisted_71, _toDisplayString(events.value[0].title), 1),
                    _hoisted_72
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("span", null, [
                      _hoisted_74,
                      _createTextVNode(" " + _toDisplayString(events.value[0].location), 1)
                    ]),
                    _createTextVNode(" / "),
                    _createElementVNode("span", null, _toDisplayString(_unref(format)(events.value[0].start_date, 'HH:mm')) + _toDisplayString(events.value[0].end_date ? ` - ${_unref(format)(events.value[0].end_date, 'HH:mm')}` : '') + " GMT", 1)
                  ]),
                  _createElementVNode("div", _hoisted_75, _toDisplayString(events.value[0].description), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            (events.value.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                  _hoisted_77,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events.value.slice(1), (event) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      class: "event-post animated-block",
                      to: `/events/${event.slug}`,
                      key: event.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("div", _hoisted_79, _toDisplayString(_unref(format)(event.start_date, 'dd')), 1),
                          _createElementVNode("div", _hoisted_80, _toDisplayString(_unref(format)(event.start_date, 'MMM')) + ".", 1)
                        ]),
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, _toDisplayString(event.title), 1),
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("span", null, [
                              _hoisted_84,
                              _createTextVNode(" " + _toDisplayString(event.location), 1)
                            ]),
                            _createTextVNode(" / "),
                            _createElementVNode("span", null, _toDisplayString(event.city), 1),
                            _createTextVNode(" / "),
                            _createElementVNode("span", null, _toDisplayString(_unref(format)(event.start_date, 'HH:mm')) + _toDisplayString(event.end_date ? ` - ${_unref(format)(event.end_date, 'HH:mm')}` : '') + " GMT", 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_85, [
              _createVNode(_component_router_link, {
                class: "btn outlined blue",
                to: "/events"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("browse all events")
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (posts.value.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_86, [
          _createElementVNode("div", _hoisted_87, [
            _hoisted_88,
            _hoisted_89,
            _createVNode(NewsPost, {
              class: "animated-block",
              layout: "main",
              post: posts.value[0]
            }, null, 8, ["post"]),
            _createElementVNode("div", _hoisted_90, [
              _hoisted_91,
              _createElementVNode("div", _hoisted_92, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(posts.value.slice(1), (post) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "item animated-block",
                    key: post.id
                  }, [
                    _createVNode(NewsPost, { post: post }, null, 8, ["post"])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_93, [
              _createVNode(_component_router_link, {
                class: "btn outlined blue",
                to: "/news"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("see all news")
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (members.value.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_94, [
          _createElementVNode("div", _hoisted_95, [
            _hoisted_96,
            _hoisted_97,
            _createElementVNode("div", _hoisted_98, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(members.value, (member) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: member.id,
                  class: "member animated-block",
                  to: `/members/${member.slug}`
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: member.picture?.url,
                      alt: "",
                      class: "member-image"
                    }, null, 8, _hoisted_99),
                    _createElementVNode("div", _hoisted_100, _toDisplayString(member.company_name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128)),
              _createVNode(_component_router_link, {
                class: "member all animated-block",
                to: "/members"
              }, {
                default: _withCtx(() => [
                  _hoisted_101,
                  _hoisted_102,
                  _hoisted_103,
                  _hoisted_104
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})